<template>
	<div class="business-card-upload">
		<img v-if="businessCardImg" class="upload-image" :src="businessCardImg.src" alt="" />
		<div v-else class="upload-image upload-image-default">
			<m-svg-icon name="investor_camera" class="upload-camera" />
		</div>
		<image-upload
			ref="upload"
			:url="IMGUPLOAD"
			:touch-size="1"
			:maxCount="1"
			:multiple="false"
			:loadingMsg="$t('正在识别')"
			field-name="serverImgFile"
			:lrz-options="{ width: 1024 }"
			class="image_upload"
			:parseData64="false"
			@chooseImages="onChooseImages"
		></image-upload>
	</div>
</template>

<script>
import { ImageUpload } from '@/assets/scripts/vue-image-upload-preview/lib/index';
import { IMGUPLOAD } from '@/fetch/host';
import { bindtap_chooseImages, handleOCRShow } from '@/utils/upload';
import { mapActions } from 'vuex';

export default {
	components: {
		ImageUpload
	},
	data() {
		return {
			businessCardImg: null,
			IMGUPLOAD
		};
	},
	methods: {
		...mapActions(['hideLoading', 'showTooltip']),

		setDefaultCard(data) {
			this.businessCardImg = {
				src: data
			};
		},

		// 绑定函数 选择图片
		onChooseImages(res) {
			bindtap_chooseImages(res).then(() => {
				this.businessCardImg = res[0];
				this.onImagesUpload(res);
			});
		},
		// 绑定函数 上传图片
		onImagesUpload(images) {
			this.$refs.upload &&
				this.$refs.upload
					.uploadImagesOCR(images)
					.then(res => {
						const imageResult = res[0];
						handleOCRShow(imageResult).then(result => {
							const { businessCard, cropBusinessCard, ...rest } = result;
							this.$emit('onUpload', {
								...rest,
								// 名片识别失败, 取值兜底
								businessCard: businessCard || imageResult?.viewUrl || '',
								cropBusinessCard: cropBusinessCard || imageResult?.cropImage || ''
							});
						});
					})
					.catch(err => {
						this.businessCardImg = null;
						this.hideLoading();
						this.showTooltip({ msg: this.$t('网络不给力，请稍后重试') });
					});
		}
	}
};
</script>

<style lang="less" scoped>
.business-card-upload {
	.upload-image {
		width: 1.18rem;
		height: 0.67rem;

		&.upload-image-default {
			background: #f6f7f8;
			border-radius: 0.02rem;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.upload-camera {
			font-size: 0.28rem;
			color: var(--ir-theme-color);
		}
	}
	.image_upload {
		// for parent
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}
</style>
